import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function Legal() {
  const [mobileOpen, setMobileOpen] = useState(false);
  return (
    <div className="bg-white text-black min-h-screen pt-32 px-6">
      <header className="fixed top-0 left-0 w-full z-50 bg-white shadow-md px-6 py-4">
  <div className="relative max-w-7xl mx-auto w-full flex items-center justify-between">

    {/* Десктоп: навигация + бутони + центрирано лого */}
    <div className="hidden md:flex w-full items-center justify-between relative">

      {/* Навигация – ляво */}
      <nav className="flex gap-6 text-sm font-semibold text-[#140D4F]">
        <a href="/#how-it-works" className="hover:text-[#0267C1]">How It Works</a>
        <a href="/#pricing" className="hover:text-[#0267C1]">Pricing</a>
        <a href="/#brands" className="hover:text-[#0267C1]">Supported Brands</a>
      </nav>

      {/* Центрирано лого */}
      <div className="absolute left-1/2 transform -translate-x-1/2">
        <a href="/#top">
          <img src="/logo.png" alt="DiagCode.AI Logo" className="h-8" />
        </a>
      </div>

      {/* Бутони  – дясно */}
      <div className="flex gap-3">
        <Link to="/login" className="px-4 py-2 text-sm font-semibold text-white bg-[#140D4F] hover:bg-[#0f0a3c] rounded">Login</Link>
        <Link to="/register" className="px-4 py-2 text-sm font-semibold text-white bg-[#FD5003] hover:bg-[#e34700] rounded">Register</Link>
      </div>
    </div>

    {/* Мобилно: ☰ меню отляво и лого в центъра */}
    <div className="flex items-center justify-between w-full md:hidden relative">

      {/* ☰ бутон */}
      <button
        onClick={() => setMobileOpen(!mobileOpen)}
        className="text-white bg-[#140D4F] hover:bg-[#0e083a] p-2 rounded-md shadow-md transition-colors"
      >
        ☰
      </button>

      {/* Центрирано лого */}
      <a href="/#top" className="absolute left-1/2 transform -translate-x-1/2">
        <img src="/logo.png" alt="DiagCode.AI Logo" className="h-8" />
      </a>
    </div>
  </div>

  {/* Мобилно меню */}
  {mobileOpen && (
    <div className="md:hidden fixed top-0 left-0 w-64 h-full bg-white z-40 shadow-lg p-6 flex flex-col gap-6">
      <button onClick={() => setMobileOpen(false)} className="text-right text-xl text-[#140D4F] mb-4">✕</button>
      <nav className="flex flex-col gap-4 text-[#140D4F] font-semibold">
        <a href="/#how-it-works" className="hover:text-[#0267C1]">How It Works</a>
        <a href="/#pricing" className="hover:text-[#0267C1]">Pricing</a>
        <a href="/#brands" className="hover:text-[#0267C1]">Supported Brands</a>
      </nav>
      <div className="flex flex-col gap-3 mt-6">
        <Link to="/login" className="w-full text-center py-2 bg-[#140D4F] text-white rounded font-semibold">Login</Link>
        <Link to="/register" className="w-full text-center py-2 bg-[#FD5003] text-white rounded font-semibold">Register</Link>
      </div>
    </div>
  )}
</header>
      <div className="max-w-4xl mx-auto space-y-16">
        <h1 className="text-4xl font-bold text-center mb-10">Legal Information</h1>

        {/* Terms of Service */}
        <section id="terms">
          <h2 className="text-2xl font-semibold text-[#140D4F] mb-4">Terms of Service</h2>
          <p className="text-gray-700 text-sm leading-relaxed">
            By accessing and using DiagCode.AI, you agree to the following terms:
            This platform is designed to provide AI-powered guidance for vehicle diagnostics and
            repair. You are responsible for interpreting the instructions and using your own judgment during any
            repair process. We do not guarantee 100% accuracy in every case, though we strive for excellence.
            Unauthorized commercial use, scraping, or reverse engineering of this platform is strictly prohibited.
          </p>
        </section>

        {/* Privacy Policy */}
        <section id="privacy">
          <h2 className="text-2xl font-semibold text-[#140D4F] mb-4">Privacy Policy</h2>
          <p className="text-gray-700 text-sm leading-relaxed">
            We collect only essential information such as email, name, and usage data to improve our service.
            Your data is stored securely and is never sold or shared with third parties without your consent.
            You have the right to request deletion or access to your stored data at any time.
            Cookies are used for session management and security purposes.
          </p>
        </section>

        {/* Cookie Policy */}
        <section id="cookies">
          <h2 className="text-2xl font-semibold text-[#140D4F] mb-4">Cookie Policy</h2>
          <p className="text-gray-700 text-sm leading-relaxed">
            Our platform uses cookies to enhance your experience — including saving your session,
            remembering preferences, and analyzing anonymous usage trends. By continuing to use
            DiagCode.AI, you agree to the use of these cookies.
          </p>
        </section>

        {/* Contact */}
        <div className="border-t border-gray-200 pt-6 text-sm text-gray-600">
          <p>Company: <span className="text-[#140D4F]">Diagcode Ltd.</span></p>
          <p>E-mail: <a href="mailto:info@diagcode.com" className="text-blue-400 hover:underline">info@diagcode.com</a></p>
          <p>Phone: <a href="tel:+359882336688" className="text-blue-400 hover:underline">+359 882 336688</a></p>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-100 border-t border-gray-200 text-gray-700 py-12 px-6 mt-20">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Logo + tagline */}
          <div>
            <h2 className="text-[#140D4F] text-2xl font-bold tracking-tight">DiagCode.AI</h2>
            <p className="mt-2 text-sm text-gray-400">
              Smarter diagnostics.<br /> Faster repairs.<br /> Future-ready.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-[#140D4F] font-semibold mb-3 text-sm uppercase">Explore</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/#top" className="hover:text-[#0267C1]">Home</a></li>
              <li><a href="/#pricing" className="hover:text-[#0267C1]">Pricing</a></li>
              <li><a href="/#how-it-works" className="hover:text-[#0267C1]">How it works</a></li>
              <li><a href="/#brands" className="hover:text-[#0267C1]">Supported Brands</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-[#140D4F] font-semibold mb-3 text-sm uppercase">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/legal#terms" className="hover:text-[#0267C1]">Terms of Service</a></li>
              <li><a href="/legal#privacy" className="hover:text-[#0267C1]">Privacy Policy</a></li>
              <li><a href="/legal#cookies" className="hover:text-[#0267C1]">Cookies</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#140D4F] font-semibold mb-3 text-sm uppercase">Contact</h4>
            <p className="text-sm text-gray-400">Have questions or suggestions?</p>
            <a href="mailto:support@diagcode.ai" className="text-sm text-blue-400 hover:underline mt-2 inline-block">
              info@diagcode.com
            </a>
          </div>
        </div>

        {/* Bottom line */}
        <div className="text-center text-xs text-gray-500 mt-10">
          &copy; {new Date().getFullYear()} DiagCode.AI. All rights reserved.
          <br className="block md:hidden" />
          <span className="italic">Powered by AI · Designed for the aftermarket revolution.</span>
        </div>
      </footer>
    </div>
  );
}
